import React from "react";
import About from "../components/About";
import Footer from "../components/Footer";
import Header from "../components/Header";
import SupportHero from "../components/SupportHero";

const Support = () => {
  return (
    <>
      <Header />
      <main>
        <SupportHero />
        <About />
        <Footer />
      </main>
    </>
  );
};

export default Support;
